import { useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';

import { useActiveCompany } from '@/lib/active-company-context';
import { useApi } from '@/lib/api-context';

import {
  documentAccessResponseSchema,
  typeAccessResponseSchema,
  type DocumentAccess,
  type Rules,
  type TypeAccess,
} from './document-access';

// Acceso por tipo de documento de la empresa activa (spec 2026-10-14 §8 D9).

const KEY = 'document-access';
const PATH = '/api/v1/quality/document-access';

export function useDocumentAccess({
  enabled,
}: {
  enabled: boolean;
}): UseQueryResult<DocumentAccess> {
  const api = useApi();
  const { activeCompanyId } = useActiveCompany();
  return useQuery({
    queryKey: [KEY, activeCompanyId],
    queryFn: async () => documentAccessResponseSchema.parse(await api.get<unknown>(PATH)).data,
    enabled: enabled && Boolean(activeCompanyId),
  });
}

export function useSaveTypeAccess(): ReturnType<
  typeof useMutation<TypeAccess, Error, { typeId: string; rules: Rules }>
> {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ typeId, rules }) =>
      typeAccessResponseSchema.parse(await api.put<unknown>(`${PATH}/${typeId}`, rules)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}
